if (!customElements.get("f-cart-milestones")) {
  customElements.define(
    "f-cart-milestones",
    class extends HTMLElement {
      connectedCallback() {
        this.render(Number(this.dataset.count));
        const refresh = async () => {
          const cart = await window.FoxThemeCartHelpers.getState();
          if (cart) this.render(cart.item_count);
        };
        window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
      }
      render(count) {
        const d = this.dataset;
        const max = Number(d.max);
        const qs = [Number(d.q1), Number(d.q2)].filter((q) => q > 0);
        this.classList.toggle("hidden", count <= 0);
        this.style.setProperty("--p", Math.min(100, (count / max) * 100) + "%");
        this.querySelectorAll(".f-ms__step").forEach((s) =>
          s.classList.toggle("is-on", count >= Number(s.dataset.q))
        );
        const next = qs.find((q) => q > count);
        const msg = next ? d.msg : d.done;
        this.querySelector("[data-ms-msg]").textContent = msg
          .replace("{{count}}", next ? next - count : 0)
          .replace("{{target}}", next || "");
      }
    }
  );
}
